const getTipShadow = (dlg) => {
    let { shadow } = getTipShadow
    if (!shadow) {
        shadow = document.createElement('div')
        shadow.className = 'overlay'
        shadow.addEventListener('click', function () {
            dlg.style.display = 'none'
            shadow.style.display = 'none'
        }, false)
        document.body.appendChild(shadow)
        getTipShadow.shadow = shadow
    }
    return shadow
}

const showTipDlg = (content) => {
    let { dlg } = showTipDlg
    if (!dlg) {
        dlg = document.createElement('div')
        dlg.className = 'error-tip'
        document.body.appendChild(dlg)
        showTipDlg.dlg = dlg
    }
    const shadow = getTipShadow(dlg)
    dlg.innerHTML = content
    dlg.style.display = 'block'
    shadow.style.display = 'block'
    return {
        dlg: showTipDlg.dlg,
        shadow
    }
}

const timeout = (content) => {
    const { dlg, shadow } = showTipDlg(content)
    setTimeout(() => {
        dlg.style.display = 'none'
        shadow.style.display = 'none'
    }, 1500)
}

export default {
    tip: showTipDlg,
    timeout
}
